import React from "react";
import { Avatar, Heading, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";

const greeting = "Hello, I am Om!";
const bio1 = "A 2nd year BTech CSE student";
const bio2 = "specialised in React";

const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="#2A4365"
    id="landing-section"
  >
    <VStack spacing={8}>
      <Avatar
        src="https://i.pravatar.cc/150?img=7"
        size="2xl"
        name="Om Kedare"
      />
      <Heading as="h4" size="md" color="white">
        {greeting}
      </Heading>
      <VStack spacing={2}>
        <Heading as="h1" size="2xl" color="white" textAlign="center">
          {bio1}
        </Heading>
        <Heading as="h1" size="2xl" color="white" textAlign="center">
          {bio2}
        </Heading>
      </VStack>
    </VStack>
  </FullScreenSection>
);

export default LandingSection;
